import {useMediaQuery} from 'react-responsive';
import './Faq.less';
import {testimonialsData} from './faqData';
import FaqSection from './FaqSection';
import {Carousel} from 'antd';
import {useRef} from 'react';
import {ArrowLeft, ArrowRight} from '@phosphor-icons/react';

const TestimonialCard = ({
	carouselRef,
	name,
	comment,
	industry
}: {
	comment?: string;
	industry: string;
	name?: string;
	carouselRef: any;
}) => (
	<div className="testimonial-cards-block">
		<div className="testimonial-card">
			<div className="testimonial-card-header">
				<div className="testimonial-name-block">
					<h3 className="testimonial-name">{name}</h3>
					<p className="testimonial-position">{industry}</p>
				</div>
			</div>
			<p className="testimonial-message">{comment}</p>
		</div>
		<div className="carousel-buttons">
			<button aria-label="Previous Slide" onClick={() => carouselRef.current?.prev()}>
				<ArrowLeft size={22} color="#1C70CA" />
			</button>
			<button aria-label="Next Slide" onClick={() => carouselRef.current?.next()}>
				<ArrowRight size={22} color="#1C70CA" />
			</button>
		</div>
	</div>
);

const Faq: React.FC = () => {
	const carouselRef = useRef<any>(null);

	return (
		<div className="faq-container">
			<FaqSection />
			<div className="testimonials-section">
				<div className="testimonials-header">
					<p className="testimonials-subtitle">TESTIMONIALS</p>
					<h1 className="testimonials-title">What people say about us</h1>
				</div>
				<section className="custom-carousel-box">
					<Carousel dots={false} ref={carouselRef}>
						{testimonialsData.map((item, index) => (
							<div key={index}>
								<TestimonialCard
									key={index}
									name={item.name}
									comment={item.comment}
									industry={item.industry}
									carouselRef={carouselRef}
								/>
							</div>
						))}
					</Carousel>
				</section>
			</div>
		</div>
	);
};

export default Faq;
